import React, { useEffect, useState } from "react";
import { ComposableMap, Geographies, Geography, Annotation } from "react-simple-maps";

const geoUrl = "/static/states.geojson";
const API_URL = process.env.REACT_APP_API_URL;

// Add Google Fonts link
const fontLink = document.createElement('link');
fontLink.href = 'https://fonts.googleapis.com/css2?family=Quicksand:wght@400;600;700&display=swap';
fontLink.rel = 'stylesheet';
document.head.appendChild(fontLink);

const auslanUsersData = {
  "New South Wales": 4000,
  "Victoria": 4000,
  "Queensland": 4000,
  "South Australia": 2000,
  "Western Australia": 2000,
  "Tasmania": 400,
  "Northern Territory": 400,
};

// Map GeoJSON state names to API state names
const stateNameMap = {
  'new south wales': 'New South Wales',
  'victoria': 'Victoria',
  'queensland': 'Queensland',
  'south australia': 'South Australia',
  'western australia': 'Western Australia',
  'tasmania': 'Tasmania',
  'australian capital territory': 'Australian Capital Territory',
  'northern territory': 'Northern Territory'
};

// State colors and center coordinates for labels
const stateConfig = {
  'western australia': { color: "#fdfbd4", color_click: "#fbf6a3", coordinates: [121.5, -26] },
  'northern territory': { color: "#d4ebfd", color_click: "#a3d4fb", coordinates: [133.5, -21.5] },
  'queensland': { color: "#e7d4fd", color_click: "#cca3fb", coordinates: [143.5, -23] },
  'south australia': { color: "#d5a6bd", color_click: "#c583a3", coordinates: [135, -30] },
  'new south wales': { color: "#eaa198", color_click: "#e17a6e", coordinates: [147, -32.5] },
  'victoria': { color: "#b2cbf2", color_click: "#86aeeb", coordinates: [144, -37] },
  'tasmania': { color: "#8ea587", color_click: "#738e6b", coordinates: [152, -42.5] },
  'australian capital territory': { color: "#eed7a1", color_click: "#e6c576", coordinates: [155.5, -36] }
};

const AuslanMap = () => {
  // const [data, setData] = useState({});
  // const [loading, setLoading] = useState(true);
  // const [error, setError] = useState(null);
  const [selectedState, setSelectedState] = useState(null);

  // useEffect(() => {
  //   const fetchData = async () => {
  //     try {
  //       console.log('API URL:', API_URL);
  //       console.log('Fetching Auslan users data...');
  //       const response = await fetch(`${API_URL}/api/auslan-users/`, {
  //         method: 'GET',
  //         headers: {
  //           'Accept': 'application/json',
  //           'Content-Type': 'application/json',
  //         },
  //         mode: 'cors'
  //       });

  //       if (!response.ok) {
  //         throw new Error(`HTTP error! status: ${response.status}`);
  //       }

  //       const result = await response.json();
  //       console.log('Received data:', result);

  //       const mapped = {};
  //       result.forEach((item) => {
  //         console.log('Mapping state:', item.state_or_territory, 'count:', item.count);
  //         mapped[item.state_or_territory] = item.count;
  //       });
  //       console.log('Final mapped data:', mapped);
  //       setData(mapped);
  //       setLoading(false);
  //     } catch (err) {
  //       console.error('Detailed error:', err);
  //       setError(`Error: ${err.message}. Please check the console for more details.`);
  //       setLoading(false);
  //     }
  //   };

  //   fetchData();
  // }, []);

  const handleStateClick = (stateName) => {
    setSelectedState(selectedState === stateName ? null : stateName);
  };

  // if (loading) {
  //   return <div style={{ width: "100%", height: "400px", display: "flex", justifyContent: "center", alignItems: "center" }}>
  //     <p>Loading map data...</p>
  //   </div>;
  // }

  // if (error) {
  //   return <div style={{ width: "100%", height: "400px", display: "flex", justifyContent: "center", alignItems: "center" }}>
  //     <div>
  //       <p style={{ color: 'red' }}>{error}</p>
  //       <p>Please check your browser's console for more details.</p>
  //     </div>
  //   </div>;
  // }

  return (
    <div style={{ 
      width: "100%", 
      maxWidth: "1000px", 
      height: "550px", 
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
    }}>
      <ComposableMap 
        projection="geoMercator"
        projectionConfig={{
          center: [135, -29.5],  // Centre of Australia
          scale: 800
        }}
        style={{ 
          width: "100%", 
          height: "100%",
          maxHeight: "550px"
        }}
      >
        <Geographies geography={geoUrl}>
          {({ geographies }) => {
            if (!geographies || geographies.length === 0) {
              return <p>Failed to load map data</p>;
            }
            return (
              <>
                {geographies.map((geo) => {
                  const stateName = geo.properties?.STATE_NAME?.toLowerCase() || '';
                  const apiStateName = stateNameMap[stateName] || '';
                  const count = auslanUsersData[apiStateName] || "No data";
                  const stateStyle = stateConfig[stateName] || { color: "#ECEFF1" };
                  const isSelected = selectedState === stateName;
                  
                  return (
                    <Geography
                      key={geo.rsmKey}
                      geography={geo}
                      onClick={() => handleStateClick(stateName)}
                      style={{
                        default: {
                          fill: isSelected ? stateStyle.color_click : stateStyle.color,
                          stroke: "#37474F",
                          strokeWidth: 2,
                          strokeLinejoin: "round",
                          strokeLinecap: "round",
                          outline: "none",
                          cursor: "pointer",
                          transition: "all 0.3s ease"
                        },
                        hover: {
                          fill: isSelected ? stateStyle.color_click : stateStyle.color,
                          stroke: "#263238",
                          strokeWidth: 3,
                          strokeLinejoin: "round",
                          strokeLinecap: "round",
                          outline: "none",
                          opacity: 0.9,
                          cursor: "pointer"
                        },
                        pressed: {
                          fill: stateStyle.color_click,
                          stroke: "#263238",
                          strokeWidth: 3,
                          strokeLinejoin: "round",
                          strokeLinecap: "round",
                          outline: "none",
                          opacity: 0.8,
                        },
                      }}
                    />
                  );
                })}
                {geographies.map((geo) => {
                  const stateName = geo.properties?.STATE_NAME?.toLowerCase() || '';
                  const apiStateName = stateNameMap[stateName] || '';
                  const count = auslanUsersData[apiStateName] || "No data";
                  const stateStyle = stateConfig[stateName];
                  const isSelected = selectedState === stateName;
                  
                  if (!stateStyle?.coordinates) return null;
                  
                  return (
                    <Annotation
                      key={`label-${geo.rsmKey}`}
                      subject={stateStyle.coordinates}
                      dx={0}
                      dy={0}
                    >
                      <text
                        textAnchor="middle"
                        alignmentBaseline="middle"
                        fill="#000"
                        style={{
                          fontSize: isSelected ? "20px" : "18px",
                          fontWeight: "600",
                          fontFamily: "'Quicksand', sans-serif",
                          textShadow: "1px 1px 1px rgba(255,255,255,0.5)",
                          letterSpacing: "0.3px",
                          transition: "all 0.3s ease"
                        }}
                      >
                        {apiStateName === 'Northern Territory' ? (
                          <>
                            <tspan x="0" dy="-20" style={{
                              fontSize: isSelected ? "20px" : "18px",
                            }}>Northern</tspan>
                            <tspan x="0" dy="20" style={{
                              fontSize: isSelected ? "20px" : "18px",
                            }}>Territory</tspan>
                            <tspan x="0" dy="25" style={{
                              fontSize: isSelected ? "20px" : "18px",
                            }}>{count}</tspan>
                          </>
                        ) : apiStateName === 'Australian Capital Territory' ? (
                          <>
                            <tspan x="0" dy="-20" style={{
                              fontSize: isSelected ? "20px" : "18px",
                            }}>Australian</tspan>
                            <tspan x="0" dy="20" style={{
                              fontSize: isSelected ? "20px" : "18px",
                            }}>Capital Territory</tspan>
                            <tspan x="0" dy="25" style={{
                              fontSize: isSelected ? "20px" : "18px",
                            }}>{count}</tspan>
                          </>
                        ) : (
                          <>
                            <tspan x="0" dy="-10" style={{
                              fontSize: isSelected ? "20px" : "18px",
                            }}>{apiStateName}</tspan>
                            <tspan x="0" dy="25" style={{
                              fontSize: isSelected ? "20px" : "18px",
                            }}>{count}</tspan>
                          </>
                        )}
                      </text>
                    </Annotation>
                  );
                })}
              </>
            );
          }}
        </Geographies>
      </ComposableMap>
    </div>
  );
};

export default AuslanMap;
